import { useState, useEffect } from 'react';

const useFetchPaginatedDataWithFilters = (axiosInstance, endpoint, pageNumber, pageSize, searchQuery,filterParams='') => {
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    if (!endpoint) {
      return;
    }
    
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      try {
        const url = `${endpoint}?pageNumber=${pageNumber}&pageSize=${pageSize}&searchQuery=${encodeURIComponent(searchQuery)}${filterParams}`;
        const response = await axiosInstance.get(url, { signal });
        
        if (response?.data?.data) {
          setData(response.data.data);
          setTotalRecords(response.data.totalRecords);
        }
      } catch (error) {
        if (error?.request?.status !== 0) {
          console.error(error);
        }
      }
    };

    fetchData();
    return () => controller.abort();
  }, [axiosInstance, endpoint, pageNumber, pageSize, searchQuery,filterParams]);

  return { data, totalRecords };
};

export default useFetchPaginatedDataWithFilters;
